// src/components/shared/TextArea.js
import React, { useState, useEffect } from 'react';
import styled, { useTheme } from 'styled-components';

const TextAreaWrapper = styled.div`
  position: relative;
  margin-bottom: ${(props) => props.theme.spacing(3)};

  label {
    position: absolute;
    top: 0;
    left: 40px;
    transform: translateY(-50%);
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.inputGray};
    font-size: 14px;
    transition: all 0.2s ease;
    padding: 0 5px;
    pointer-events: none;
  }

  textarea {
    width: 100%;
    padding: ${(props) => props.theme.spacing(2)};
    padding-left: 20px;
    font-size: 16px;
    border: 1px solid ${(props) => props.theme.colors.inputGray};
    border-radius: 5px;
    background-color: ${(props) => props.theme.colors.surface};
    color: ${(props) => props.theme.colors.textPrimary};
    outline: none;
    height: 100px; /* Adjust the default height */
    resize: vertical; /* Allow vertical resizing */

    &:focus {
      border-color: ${(props) => props.theme.colors.textPrimary};
    }

    &:focus + label,
    &:not(:placeholder-shown) + label {
      color: ${(props) => props.theme.colors.inputGray};
      font-size: 14px;
    }

    &::placeholder {
      color: transparent; /* Hide placeholder text when label is used */
    }
  }
`;

const TextArea = ({ label, value, onChange, placeholder }) => {
  const [hasValue, setHasValue] = useState(false);

  useEffect(() => {
    if (value && value.length > 0) {
      setHasValue(true);
    } else {
      setHasValue(false);
    }
  }, [value]);

  return (
    <TextAreaWrapper>
      <textarea
        value={value}
        onChange={onChange}
        placeholder={placeholder || ' '}
      />
      <label className={hasValue ? 'active' : ''}>{label}</label>
    </TextAreaWrapper>
  );
};

export default TextArea;
